// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TutorRouteImport } from './routes/tutor'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as ReviewerRouteImport } from './routes/reviewer'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as HistoryRouteImport } from './routes/history'
import { Route as HelpRouteImport } from './routes/help'
import { Route as GeneratorRouteImport } from './routes/generator'
import { Route as FeaturesRouteImport } from './routes/features'
import { Route as EssayWriterRouteImport } from './routes/essay-writer'
import { Route as EssayHelpRouteImport } from './routes/essay-help'
import { Route as EssayCheckerRouteImport } from './routes/essay-checker'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AppRouteImport } from './routes/app'
import { Route as AccountRouteImport } from './routes/account'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CheckoutReturnRouteImport } from './routes/checkout.return'
import { Route as HistoryIndexRouteImport } from './routes/history.index'
import { Route as HistoryIdRouteImport } from './routes/history.$id'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'

const TutorRoute = TutorRouteImport.update({
            id: '/tutor',path: '/tutor',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const ReviewerRoute = ReviewerRouteImport.update({
            id: '/reviewer',path: '/reviewer',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const HistoryRoute = HistoryRouteImport.update({
            id: '/history',path: '/history',getParentRoute: () => rootRouteImport
          })
const HelpRoute = HelpRouteImport.update({
            id: '/help',path: '/help',getParentRoute: () => rootRouteImport
          })
const GeneratorRoute = GeneratorRouteImport.update({
            id: '/generator',path: '/generator',getParentRoute: () => rootRouteImport
          })
const FeaturesRoute = FeaturesRouteImport.update({
            id: '/features',path: '/features',getParentRoute: () => rootRouteImport
          })
const EssayWriterRoute = EssayWriterRouteImport.update({
            id: '/essay-writer',path: '/essay-writer',getParentRoute: () => rootRouteImport
          })
const EssayHelpRoute = EssayHelpRouteImport.update({
            id: '/essay-help',path: '/essay-help',getParentRoute: () => rootRouteImport
          })
const EssayCheckerRoute = EssayCheckerRouteImport.update({
            id: '/essay-checker',path: '/essay-checker',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const BlogRoute = BlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const AppRoute = AppRouteImport.update({
            id: '/app',path: '/app',getParentRoute: () => rootRouteImport
          })
const AccountRoute = AccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const CheckoutReturnRoute = CheckoutReturnRouteImport.update({
            id: '/checkout/return',path: '/checkout/return',getParentRoute: () => rootRouteImport
          })
const HistoryIndexRoute = HistoryIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => HistoryRoute
          })
const HistoryIdRoute = HistoryIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => HistoryRoute
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => BlogRoute
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => BlogRoute
          })





const BlogRouteChildren = {
  BlogSlugRoute: BlogSlugRoute,BlogIndexRoute: BlogIndexRoute
}

const BlogRouteWithChildren = BlogRoute._addFileChildren(BlogRouteChildren)




const HistoryRouteChildren = {
  HistoryIdRoute: HistoryIdRoute,HistoryIndexRoute: HistoryIndexRoute
}

const HistoryRouteWithChildren = HistoryRoute._addFileChildren(HistoryRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,AccountRoute: AccountRoute,AppRoute: AppRoute,AuthRoute: AuthRoute,BlogRoute: BlogRouteWithChildren,ContactRoute: ContactRoute,EssayCheckerRoute: EssayCheckerRoute,EssayHelpRoute: EssayHelpRoute,EssayWriterRoute: EssayWriterRoute,FeaturesRoute: FeaturesRoute,GeneratorRoute: GeneratorRoute,HelpRoute: HelpRoute,HistoryRoute: HistoryRouteWithChildren,PricingRoute: PricingRoute,PrivacyRoute: PrivacyRoute,ReviewerRoute: ReviewerRoute,TermsRoute: TermsRoute,TutorRoute: TutorRoute,CheckoutReturnRoute: CheckoutReturnRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)